{
	"category": {
		"doctoral_and_specialization": "Dottorato e specializzazione",
		"first_year": "Primo anno",
		"later_years": "Anni successivi"
	},
	"channel": {
		"email": "Email",
		"residence_pec": "PEC della struttura"
	},
	"columns": {
		"actions": "Azioni",
		"channel": "Canale",
		"deadline": "Scadenza",
		"name": "Studente",
		"protocol": "Protocollo",
		"quota": "Quota",
		"reply": "Ultima risposta",
		"sent": "Invio",
		"state": "Stato"
	},
	"contact": {
		"command": "Annota un contatto",
		"description": "Scrivi come e quando hai avvisato lo studente, per esempio per telefono. La nota non cambia il termine dell'offerta.",
		"error": "Non è stato possibile salvare la nota.",
		"label": "Nota",
		"save": "Salva la nota",
		"success": "Nota salvata.",
		"title": "Annotare un contatto con lo studente"
	},
	"decision": {
		"accept": "Accettazione",
		"decline": "Rinuncia"
	},
	"errors": {
		"default": "Non è stato possibile caricare le offerte.",
		"offer_not_bounced": "L'offerta non risulta più non consegnata.",
		"offer_not_to_send_by_pec": "L'offerta non è da inviare dalla PEC della struttura."
	},
	"expiries": {
		"confirm": {
			"command": "Conferma la decadenza",
			"confirm": "Conferma la decadenza",
			"description": "Lo studente perde il posto in questa struttura e riceve l'email della decadenza. Il posto passa al successivo in graduatoria con il prossimo calcolo.",
			"error": "Non è stato possibile confermare la decadenza.",
			"success": "Decadenza confermata.",
			"title": "Confermare la decadenza?"
		},
		"delivered": "Consegnata",
		"due": "Da confermare entro il {{date}}",
		"empty": "Nessuna decadenza da confermare.",
		"expired": "Scaduta alle 24:00 di {{day}}",
		"late": "In ritardo",
		"late_reply": "Tardiva",
		"late_reply_text": "{{decision}} ricevuta il {{date}}",
		"not_delivered": "Non consegnata",
		"reminder": "Prima di confermare controlla se lo studente ha risposto alla PEC del bando o per un'altra via.",
		"reply": {
			"accept": "Accetta il posto",
			"after_deadline": "La risposta è arrivata dopo la scadenza: non annulla la decadenza.",
			"closed": "L'offerta non è più da confermare: ora è «{{state}}».",
			"command": "Registra la risposta ricevuta",
			"date": "Giorno di ricezione",
			"decision": "Risposta",
			"decline": "Rinuncia al posto",
			"description": "Carica il messaggio ricevuto come prova (.eml, PDF o immagine, al massimo 25 MB). Da un .eml il sistema propone l'orario di ricezione: controllalo prima di registrare.",
			"error": "Non è stato possibile registrare la risposta.",
			"file": "Prova della risposta",
			"not_read": "Il file non dice quando è arrivato: scrivi l'orario della ricevuta.",
			"proposed": "Orario di ricezione letto dal messaggio: controllalo.",
			"reading": "Lettura del messaggio…",
			"record": "Registra la risposta",
			"success_accept": "Accettazione registrata: la decadenza è annullata.",
			"success_decline": "Rinuncia registrata.",
			"time": "Ora di ricezione",
			"title": "Registrare la risposta dello studente",
			"too_large": "Il file supera i 25 MB.",
			"upload_failed": "Il file non è stato caricato.",
			"uploading": "Caricamento…"
		},
		"sent": "Inviata il {{date}}",
		"title": "Decadenze da confermare"
	},
	"launch": {
		"assigned_note": "I destinatari sono gli assegnatari della graduatoria definitiva, versione {{version}}. Il gestore non può aggiungere né togliere destinatari.",
		"assigned_title_one": "{{count}} studente riceverà l'offerta",
		"assigned_title_other": "{{count}} studenti riceveranno l'offerta",
		"blocked": {
			"already_launched": "Le offerte di questo bando sono già state avviate.",
			"contract_info_link": "Completali nella scheda della struttura",
			"contract_info_missing": "Mancano i dati del contratto e dei pagamenti (IBAN, intestatario, firma, deposito): le offerte li riportano e non partono senza.",
			"ministry_answer_missing_one": "{{seats}} posti DSU sono rimasti scoperti e {{count}} studente della lista della quota 70% non ha un posto DSU: le offerte partono quando registri la risposta del Ministero. Con il sì, quei posti vanno ai primi della lista 70% a tariffa DSU; con il no restano scoperti. Se la risposta non arriva, l'admin generale può sbloccare le offerte.",
			"ministry_answer_missing_other": "{{seats}} posti DSU sono rimasti scoperti e {{count}} studenti della lista della quota 70% non hanno un posto DSU: le offerte partono quando registri la risposta del Ministero. Con il sì, quei posti vanno ai primi della lista 70% a tariffa DSU; con il no restano scoperti. Se la risposta non arriva, l'admin generale può sbloccare le offerte.",
			"ranking_not_final": "La graduatoria non è ancora definitiva: le offerte si possono avviare quando finisce la finestra delle segnalazioni degli studenti.",
			"ranking_not_final_until": "La graduatoria non è ancora definitiva: le offerte si possono avviare dopo il {{date}}, quando finisce la finestra delle segnalazioni degli studenti.",
			"recalculation_pending": "La graduatoria si sta ricalcolando, per esempio dopo il sì del Ministero: le offerte partono dalla nuova versione. Ricarica la pagina tra un minuto."
		},
		"changed": "La graduatoria è cambiata (versione {{number}}): controlla di nuovo i destinatari.",
		"command": "Avvia le offerte",
		"confirm": "Avvia",
		"confirm_description_one": "Parte {{count}} offerta. {{when}} Dopo l'avvio, ogni nuovo calcolo della graduatoria crea da solo le offerte dei posti che si liberano.",
		"confirm_description_other": "Partono {{count}} offerte. {{when}} Dopo l'avvio, ogni nuovo calcolo della graduatoria crea da solo le offerte dei posti che si liberano.",
		"confirm_title": "Avviare le offerte?",
		"error": "Non è stato possibile avviare le offerte. Riprova.",
		"later": "Le offerte partiranno {{day}} alle {{time}}.",
		"none": "Nessun assegnatario nella graduatoria definitiva: non c'è nessuna offerta da avviare.",
		"now": "Le email partono subito.",
		"success_one": "Offerte avviate: {{count}} offerta",
		"success_other": "Offerte avviate: {{count}} offerte",
		"text_note": "Il testo è quello delle regole del bando, con i dati della struttura e uno studente di esempio.",
		"text_title": "Testo dell'offerta",
		"title": "Avvio delle offerte"
	},
	"list": {
		"empty": "Nessuna offerta.",
		"empty_filtered": "Nessuna offerta in questo stato.",
		"expiries_link": "Decadenze da confermare",
		"filter": "Stato",
		"launched": "Offerte avviate il {{date}}",
		"overbooked": "Posti occupati oltre la quota dopo una correzione: {{q30}} nella quota 30%, {{q70}} nella quota 70%. Nessuna offerta viene tolta.",
		"unfilled": "Posti non coperti: {{q30}} nella quota 30%, {{q70}} nella quota 70%."
	},
	"origin": {
		"initial": "Iniziale",
		"scrolling": "Scorrimento"
	},
	"page_title": "Offerte",
	"pec": {
		"body": "Testo",
		"command": "Invia dalla PEC",
		"copied": "Copiato.",
		"copy": "Copia",
		"date": "Giorno della ricevuta",
		"description": "Copia il testo e invialo dalla PEC della struttura all'indirizzo dello studente. Poi registra l'orario della ricevuta di accettazione: il termine dell'offerta parte da lì.",
		"error": "Non è stato possibile registrare l'invio.",
		"future": "L'orario non può essere nel futuro.",
		"recipient": "Destinatario",
		"record": "Registra l'invio",
		"subject": "Oggetto",
		"success": "Invio registrato: il termine dell'offerta è partito.",
		"time": "Ora della ricevuta",
		"title": "Inviare l'offerta dalla PEC della struttura"
	},
	"quota": {
		"q30": "Quota 30%",
		"q70": "Quota 70%"
	},
	"reply_state": {
		"ignored": "Ignorata",
		"late": "Tardiva"
	},
	"resend": {
		"command": "Invia di nuovo",
		"confirm": "Invia di nuovo",
		"description": "L'offerta riparte allo stesso indirizzo alla prossima apertura dell'orario di invio, con il termine che riparte dal nuovo invio. Se anche questa email non arriva, il termine corre comunque: puoi contattare lo studente per telefono e annotarlo.",
		"error": "Non è stato possibile inviare di nuovo l'offerta.",
		"success": "L'offerta ripartirà alla prossima apertura dell'orario di invio.",
		"title": "Inviare di nuovo l'offerta?"
	},
	"row": {
		"by_pec": "Da inviare dalla PEC della struttura",
		"contact_note": "Contatto: {{note}}",
		"deadline": "entro le 24:00 di {{day}}",
		"not_delivered": "L'email non è arrivata",
		"reply": "{{decision}} il {{date}}",
		"reply_none": "Nessuna",
		"send_after": "Parte il {{date}}"
	},
	"state": {
		"accepted": "Accettata",
		"bounced": "Non consegnata",
		"declined": "Rinunciata",
		"expired": "Decaduta",
		"expiry_proposed": "Da confermare",
		"renounced_after_acceptance": "Rinuncia dopo l'accettazione",
		"revoked": "Revocata",
		"scheduled": "Da inviare",
		"sent": "Inviata",
		"withdrawn": "Ritirata"
	}
}
